import React, { useState } from "react";
import "./Causes.css";
import { Input } from "../../../ui";
export const Causes = ({ details }) => {
  const [search, setSearch] = useState("");

  if (!Array.isArray(details)) return null;

  // Count occurrences
  const causeCounts = details.reduce((acc, item) => {
    const cause = item.cause?.trim();
    if (!cause) return acc;
    acc[cause] = (acc[cause] || 0) + 1;
    return acc;
  }, {});

  const causeList = Object.entries(causeCounts).map(([cause, count]) => ({
    cause,
    count,
  }));

  // Apply search
  const normalizedSearch = search.trim().toLowerCase();

  const filteredCauses = causeList
    .filter((item) => item.cause.toLowerCase().includes(normalizedSearch))
    .sort((a, b) => b.count - a.count);

  return (
    <div className="causes-container">
      <Input
        type="text"
        placeholder="Search causes..."
       
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="causes-table">
        {filteredCauses.map((item, index) => (
          <React.Fragment key={index}>
            <div className="cause-cell count-cell">{item.count}</div>
            <div className="cause-cell cause-text">{item.cause}</div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
